import { TextRegular } from 'UiKit/typography';

import { getMenuPermissions } from 'Helper/getMenuPermissions';

import ActionButton from 'View/schedule-ruleset/components/action-button';

import AccountColumn from 'View/schedule-ruleset/components/account-column';

import styles from './styles.module.css';

const buildTableList = (t) => {
  const accessPermission = getMenuPermissions('master-data', 'schedule-ruleset');
  const tableList = [
    {
      name: t('tableColumnBrand'),
      width: 145,
      key: 'brandName',
      sortKey: 'brandName',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnAccountId'),
      width: 430,
      key: 'account',
      component: ({ value }) => {
        return <AccountColumn value={value} />;
      },
    },
    {
      name: t('tableColumnLivestreamType'),
      width: 200,
      key: 'type',
      sortKey: 'type',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnTotalHosts'),
      width: 163,
      key: 'totalHost',
      sortKey: 'totalHost',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnLiveTimePerDay'),
      width: 250,
      key: 'liveHours',
      sortKey: 'liveHours',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
  ];

  if (accessPermission?.isCanEdit || accessPermission?.isCanDelete) {
    tableList.push({
      name: t('tableColumnAction'),
      key: 'action',
      width: 185,
      position: 'center',
      component: ({ values }) => <ActionButton values={values} />,
    });
  }

  return tableList;
};

export default buildTableList;